export default __webpack_public_path__ + "static/media/drawing-woman8-focusfill.0af95f3d.svg";